import { render, staticRenderFns } from "./unsaved.vue?vue&type=template&id=5366ffe8"
import script from "./unsaved.vue?vue&type=script&lang=js"
export * from "./unsaved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports